import styled from 'styled-components';
import {
  LayoutProps,
  MarginProps,
  PaddingProps,
  display,
  maxWidth,
  space,
} from 'styled-system';

import { mediaRetina } from 'theme/theme';

export const ButtonGroup = styled.div<
  Partial<MarginProps & PaddingProps & LayoutProps>
>`
  display: flex;
  ${display} ${space} ${maxWidth};
  > * {
    &:not(:first-child) {
      margin-left: -1px;
      ${mediaRetina} {
        margin-left: -2px;
      }
    }
  }
`;
